// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{
    --primary-color: rgb(17,86,102);
    --primary-darker: rgb(9,48,56);
}

*{
    box-sizing: border-box;
    outline: 0;
}

body{
    margin: 0;
    padding: 0;
    background-color: var(--primary-color);
    font-family: 'Open sans', sans-serif;
    font-size: 1.3em;
    line-height: 1.5em;
}

.container{
    max-width: 640px;
    margin: 50px auto;
    background-color: #fff;
    padding: 20px;
    border-radius: 10px;

}

button  {
    display: block;
    width: 100%;
    margin-bottom: 10px;
}

input{
    font-size: 24px;
    padding: 0 20px;
}

input:focus{
    outline: 1px solid var(--primary-color);
}

button{
    border: none;
    background: var(--primary-color);
    color: #fff;
    font-size: 18px;
    font-weight: 700;
    height: 50px;
    cursor: pointer;
    margin-top: 30px;
}

button:hover{
    background-color: var(--primary-darker);
}

.resultado{
    font-size: 2em;
    color: var(--primary-color);
    margin: 40px 5px;
    width: 100%;
}

input[type="checkbox"] {
    width: 20px;
    height: 20px;
}

h1{
    text-align: center;
}`, "",{"version":3,"sources":["webpack://./SRC/assets/modelo.css"],"names":[],"mappings":"AAEA;IACI,+BAA+B;IAC/B,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,SAAS;IACT,UAAU;IACV,sCAAsC;IACtC,oCAAoC;IACpC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;;AAEvB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,YAAY;IACZ,gCAAgC;IAChC,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,cAAc;IACd,2BAA2B;IAC3B,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap');\r\n\r\n:root{\r\n    --primary-color: rgb(17,86,102);\r\n    --primary-darker: rgb(9,48,56);\r\n}\r\n\r\n*{\r\n    box-sizing: border-box;\r\n    outline: 0;\r\n}\r\n\r\nbody{\r\n    margin: 0;\r\n    padding: 0;\r\n    background-color: var(--primary-color);\r\n    font-family: 'Open sans', sans-serif;\r\n    font-size: 1.3em;\r\n    line-height: 1.5em;\r\n}\r\n\r\n.container{\r\n    max-width: 640px;\r\n    margin: 50px auto;\r\n    background-color: #fff;\r\n    padding: 20px;\r\n    border-radius: 10px;\r\n\r\n}\r\n\r\nbutton  {\r\n    display: block;\r\n    width: 100%;\r\n    margin-bottom: 10px;\r\n}\r\n\r\ninput{\r\n    font-size: 24px;\r\n    padding: 0 20px;\r\n}\r\n\r\ninput:focus{\r\n    outline: 1px solid var(--primary-color);\r\n}\r\n\r\nbutton{\r\n    border: none;\r\n    background: var(--primary-color);\r\n    color: #fff;\r\n    font-size: 18px;\r\n    font-weight: 700;\r\n    height: 50px;\r\n    cursor: pointer;\r\n    margin-top: 30px;\r\n}\r\n\r\nbutton:hover{\r\n    background-color: var(--primary-darker);\r\n}\r\n\r\n.resultado{\r\n    font-size: 2em;\r\n    color: var(--primary-color);\r\n    margin: 40px 5px;\r\n    width: 100%;\r\n}\r\n\r\ninput[type=\"checkbox\"] {\r\n    width: 20px;\r\n    height: 20px;\r\n}\r\n\r\nh1{\r\n    text-align: center;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
